import {
    AcademicVacationActionTab,
    AcademicVacationList,
} from 'src/pages/edu/AcademicVacations/components';
import { StudentLayout } from 'src/components/Layout/student/StudentLayout';
import { useGetAcademicLeavesQuery } from 'src/api/endpoints/academic';
import Loader from 'src/components/Loader';
import { FC, ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { AuthorizedUserProps } from 'src/routes/components/PrivateRoute';

export const AcademicVacations: FC<AuthorizedUserProps> = (
    props: AuthorizedUserProps
): ReactElement => {
    const { data, isLoading, isFetching } = useGetAcademicLeavesQuery({
        params: { branchId: props.currentBranchId },
    });

    return (
        <StudentLayout auth={props}>
            <Helmet title={'Академические отпуска'} />

            <AcademicVacationActionTab
                isFetching={isFetching}
                branchId={props.currentBranchId}
            />

            {isLoading ? (
                <Loader />
            ) : data?.length ? (
                <AcademicVacationList
                    branch={props.currentBranchId}
                    data={data ?? []}
                    isFetching={isFetching}
                />
            ) : (
                'Ничего не найдено'
            )}
        </StudentLayout>
    );
};
